import EllipsisBlock from './EllipsisBlock';

export default EllipsisBlock;
